import Axios from "middleware/axiosInstance";
import { Button, Space, Table, Pagination } from "antd";
import { useEffect, useState } from "react";
import Loading from "layouts/Loading/Loading";
import { Link } from "react-router-dom";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
const CommodityAndServices = () => {
  const [commodityDocs, setCommodityDocs] = useState(null);
  const [data, setData] = useState(null);
  const getCommodityDocs = () => {
    // Axios.get("/get_paginate_commodity")
    Axios.get("/commodity")
      .then((res) => {
        setCommodityDocs(res.data);
        // setCommodityDocs(res.data.data);
        // setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changePageHandler = (page) => {
    Axios.get(`/get_paginate_commodity?page=${page}`)
      .then((res) => {
        setCommodityDocs(res.data.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const deleteCommodity = (item) => {
    if (window.confirm(`آیا کالای "${item.name}" حذف گردد؟ \n\n هشدار: \n تمام اسناد ثبت شده شامل این کالا نیز حذف می گردند!  \n `)) {
      deleteCommodityHandler(item);
    }
  };

  const deleteCommodityHandler = (item) => {
    Axios.delete(`commodity/${item.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
          OpenNotificationWithIcon("حذف موفق", "حذف کالا با موفقیت انجام شد");
        }
      })
      .catch((err) => {
        console.log(err);
        OpenNotificationWithIcon("حذف ناموفق", "حذف کالا ناموفق بود");
      })
      .finally(() => {
        getCommodityDocs();
      });
  };

  const columns = [
    {
      title: "نام کالا",
      dataIndex: "name",
      key: "name",
      // filters: data.map((item) => {
      //   return (
      //     {
      //       "text": item.name,
      //       "value": item.goods_name,
      //     }
      //   )
      // }),

      // filteredValue: filteredInfo.name || null,
      // sorter: (a, b) => a.name.length - b.name.length,
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),

      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "گروه کالایی",
      dataIndex: "goods_name",
      key: "goods_name",
      filters: commodityDocs
        ?.filter(
          (v, i, a) =>
            a.findIndex((v2) => v2.goods_group_id === v.goods_group_id) === i
        )
        .map((item) => {
          return {
            text: item.goods_name,
            value: item.goods_name,
          };
        }),
      // filterMultiple: false,
      filteredValue: filteredInfo.goods_name || null,
      onFilter: (value, record) => record.goods_name.includes(value),
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),

      sortOrder:
        sortedInfo.columnKey === "goods_name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "شناسه کالا",
      dataIndex: "shenaseh",
      key: "shenaseh",
      // render: (date) => (
      //   <span>{date}
      //   </span>
      // ),
      sorter: (a, b) => a.shenaseh - b.shenaseh,
      sortOrder: sortedInfo.columnKey === "shenaseh" ? sortedInfo.order : null,
      ellipsis: true,
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, item) => (
        // <Space size="middle">

        //   <Link to={`/warehouse/commodity-and-services-details/${item.id}`}>جزییات</Link>
        //   {/* <Link to={`/war`}>جزییات</Link> */}
        //   <span
        //     onClick={
        //       () => deleteCommodity(item)
        //     }
        //   >
        //     حذف
        //   </span>
        // </Space >
        <Space size="small">
          <Link
            to={`/warehouse/edit-commodity-and-services/${item.id}`}
            className="btn btn-primary btn-sm"
          >
            ویرایش
          </Link>
          <Link
            to={`/warehouse/commodity-and-services-details/${item.id}`}
            className="btn btn-success btn-sm"
          >
            جزییات
          </Link>
          <button
            onClick={() => deleteCommodity(item)}
            className="btn btn-danger btn-sm"
          >
            حذف
          </button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getCommodityDocs();
  }, []);

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">کالاها و خدمات تعریف شده</h5>
        {commodityDocs ? (
          <>
            <Space
              style={{
                marginBottom: 16,
              }}
            >
              <Button onClick={clearFilters}>حذف فیلترها</Button>
              <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
            </Space>
            <Table
              columns={columns}
              dataSource={commodityDocs}
              onChange={handleChange}
              pagination={false}
            />
            <div className="d-flex justify-content-center align-items-center w-100 mt-3">
              {data?.per_page && (
                <Pagination
                  onChange={(page) => changePageHandler(page)}
                  defaultCurrent={1}
                  pageSize={data?.per_page}
                  total={data?.total}
                  showSizeChanger={false}
                />
              )}
            </div>
          </>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default CommodityAndServices;
